import React from 'react';
import { Button } from "@/components/ui/button";
import { ArrowLeft, ArrowRight } from 'lucide-react';

const Pagination = ({ currentPage, totalPages, paginate }) => {
  const scrollToResources = () => {
    const resourcesElement = document.getElementById('recursos');
    if (resourcesElement) {
      resourcesElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handlePageChange = (page) => {
    paginate(page);
    scrollToResources();
  };

  return (
    <nav className="flex justify-center mt-12">
      <ul className="flex items-center space-x-2">
        <li>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className="hover:bg-gray-100"
          >
            <ArrowLeft size={18} />
          </Button>
        </li>
        {[...Array(totalPages).keys()].map((number) => (
          <li key={number + 1}>
            <Button
              onClick={() => handlePageChange(number + 1)}
              className={`
                ${currentPage === number + 1 
                  ? 'bg-primary text-white hover:bg-accent' 
                  : 'bg-white text-black hover:bg-accent hover:text-white'}
                w-10 h-10 p-0
              `}
            >
              {number + 1}
            </Button>
          </li>
        ))}
        <li>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="hover:bg-gray-100"
          >
            <ArrowRight size={18} />
          </Button>
        </li>
      </ul>
    </nav>
  );
}

export default Pagination;